import { clampDate, dayStart, dayEnd } from "../../../Helpers/Utils";
import React, { useEffect, useState } from "react";
import { setBooking, setPickup, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import NextPrev from "../../../Helpers/Components/NextPrev";
import Handler from "../../../Helpers/Components/Handler"
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from 'react-select'

const Trip = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const pd = booking?.pickupDetails || {}
    const picked = pd?.entered ? pd?.pickup : ""
    useEffect(() => {
        if (!pd?.default && pd?.pickup && !pd?.entered) dispatch(setPickup({ default: pd.pickup }))
    }, [pd?.pickup, pd?.default, pd?.entered])
    const sameMinute = (a, b) => Math.floor(new Date(a).getTime() / 60000) === Math.floor(new Date(b).getTime() / 60000)
    const differs = !!(picked && pd?.default && !sameMinute(picked, pd.default) && new Date(picked) > new Date(pd.default))

    const daysFor = (pickup) => {
        const delivery = new Date(booking?.deliveryDetails?.delivery).getTime()
        const diff = (new Date(pickup).getTime() - delivery) / 3600000
        const units = Math.ceil(diff / 12)
        if (units <= 0) return 0
        if (units / 2 === 0.5) return 1
        let point = 0
        if (units % 2 !== 0) {
            const diff1 = (new Date(pickup).getTime() - 2 * 3600000 - delivery) / 3600000
            point = Math.ceil(diff1 / 12) % 2 !== 0 ? 0.5 : 0
        }
        return Math.floor(units / 2) + point
    }
    const setSteps = () => {
        dispatch(setStep(0))
    }
    const handleNext = async () => {
        if (!picked) {
            toast.error("Pickup date is required")
        } else if (!booking?.pickupDetails?.location) {
            toast.error("Pickup location is required")
        } else if (differs && !String(pd?.reason || "").trim()) {
            toast.error("Reason is required when the pickup date is later than the default pickup date")
        } else if (!booking?.pickupBy) {
            toast.error("Pickup By is required")
        } else if (!booking?.km?.end || Number(booking?.km?.end) < 0) {
            toast.error("Invalid End KM");
        } else if (Number(booking?.km?.end) <= Number(booking?.km?.start)) {
            toast.error("End KM must be greater than Start KM")
        } else if (!booking?.fuel?.end || Number(booking?.fuel?.end) < 0 || Number(booking?.fuel?.end) > 100) {
            toast.error("Invalid End Fuel");
        } else if (new Date(picked) > new Date()) {
            toast.error("Pickup date is greater than today");
        } else if (new Date(booking?.deliveryDetails?.delivery) >= new Date(picked)) {
            toast.error("Pickup date must be after the delivery date")
        } else if (booking?.totalDays && daysFor(picked) > Number(booking?.totalDays) + Number(booking?.point || 0)) {
            toast.error("Number of days can't be more than the booked days")
        } else {
            setLoading(true);
            let data = {
                pickupDetails: (({ entered, ...rest }) => ({ ...rest, reason: differs ? String(rest?.reason || "").trim() : "" }))(booking?.pickupDetails || {}), pickupBy: booking?.pickupBy,
                km: { end: Number(booking?.km?.end || 0), ...(booking?.km?.start ? { start: Number(booking?.km?.start || 0) } : {}) },
                fuel: { end: Number(booking?.fuel?.end || 0), ...(booking?.fuel?.start ? { start: Number(booking?.fuel?.start || 0) } : {}) },
                fastTag: { end: Number(booking?.fastTag?.end || 0), ...(booking?.fastTag?.start ? { start: Number(booking?.fastTag?.start || 0) } : {}) }
            }
            const response = await Handler({ method: 'patch', url: `/booking/close/second/update/${props?.bookingId}`, data })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(2))
            } else {
                toast.error(response?.message)
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row mt-3">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="ddate" className="form-label"> Delivery Date & Time </label>
                        <input readOnly name="ddate" id="ddate" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="defaultPickup" className="form-label"> Default Pickup Date & Time </label>
                        <input readOnly id="defaultPickup" disabled className="form-control input-theme" value={pd?.default ? moment(new Date(pd.default)).format("DD/MM/YYYY hh:mm A") : ""} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="pdate" className="form-label"> Actual Pickup Date & Time </label>
                        <div className=" datepicker-top">
                            <DatePicker
                                className="input-theme"
                                value={picked ? new Date(picked) : ""}
                                placeholder="Select pickup date & time"
                                onChange={(e) => {
                                    if (!e) { dispatch(setPickup({ entered: false })); return }
                                    const date = new Date(e);
                                    const minutes = date.getMinutes();
                                    const roundedMinutes = Math.floor(minutes / 5) * 5; // round down so the time never goes past now
                                    date.setMinutes(roundedMinutes);
                                    date.setSeconds(0);
                                    date.setMilliseconds(0);
                                    dispatch(setPickup({ pickup: clampDate(date, booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : new Date(), new Date(Math.floor(Date.now() / 300000) * 300000 + 299999))?.toString(), entered: true }))
                                }}
                                format="DD/MM/YYYY hh:mm A"
                                plugins={[
                                    <TimePicker position="bottom" hideSeconds mStep={5} />
                                ]}
                                minDate={dayStart(booking?.deliveryDetails?.delivery ? new Date(booking?.deliveryDetails?.delivery) : new Date())}
                                maxDate={dayEnd(new Date())}
                                disabled={loading || !booking?.deliveryDetails?.delivery}
                            />
                        </div>
                    </div>
                    {differs ? <div className="mb-3">
                        <label htmlFor="pickupReason" className="form-label"> Reason for later pickup date & time </label>
                        <textarea id="pickupReason" rows={2} maxLength={300} autoComplete="off" disabled={loading} className="form-control input-theme" value={pd?.reason || ""} onChange={(e) => dispatch(setPickup({ reason: e.target.value }))} />
                    </div> : ""}
                </div>

            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="location" className="form-label"> Delivery Location </label>
                        <input readOnly name="location" id="location" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.location || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pickupLocation" className="form-label"> Pickup Location </label>
                        <input onChange={(e) => dispatch(setPickup({ location: e.target.value }))} name="pickupLocation" id="pickupLocation" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.location || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="closedBy" className="form-label"> Booking Closed By </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            onChange={(e) => { dispatch(setBooking({ pickupBy: e.value })) }} value={props?.leadList?.length && booking.pickupBy ? (props?.leadList?.find(element => element.value === booking?.pickupBy) || "") : ""} options={props.leadList} />

                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="package" className="form-label"> Package </label>
                        <input name="package" id="package" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.package || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="segment" className="form-label"> Type of Car </label>
                        <input name="segment" id="segment" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.car?.segment || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startKm" className="form-label"> Start KM </label>
                        <input name="startKm" id="startKm" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.km?.start || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endKm" className="form-label"> End KM </label>
                        <input name="endKm" id="endKm" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ km: { ...(booking?.km?.start ? { start: booking?.km?.start } : {}), end: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.km?.end || ""} />
                    </div>
                </div>
                {
                    booking?.km?.end ?
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="usedKm" className="form-label"> Used KM </label>
                                <input name="usedKm" id="usedKm" autoComplete="off" readOnly disabled className="form-control input-theme text-uppercase" value={(Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) > 0 ? (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) : 0} />
                            </div>
                        </div> : ""
                }

            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFuel" className="form-label"> Start Fuel </label>
                        <input name="startFuel" id="startFuel" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.fuel?.start ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endFuel" className="form-label"> End Fuel </label>
                        <input name="endFuel" id="endFuel" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fuel: { ...(booking?.fuel?.start ? { start: booking?.fuel?.start } : {}), end: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fuel?.end ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="usedFuel" className="form-label"> Used Fuel </label>
                        <input name="usedFuel" id="usedFuel" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) > 0 ? (Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) : 0} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFastTag" className="form-label"> Start FasTag </label>
                        <input name="startFastTag" id="startFastTag" readOnly autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.fastTag?.start ?? 0} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="endFastTag" className="form-label"> End FasTag </label>
                        <input name="endFastTag" id="endFastTag" onChange={(e) => { if (/^-?\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fastTag: { ...(booking?.fastTag?.start ? { start: booking?.fastTag?.start } : {}), end: (e.target.value) } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fastTag?.end ?? 0} />
                    </div>
                </div>
                {
                    (Number(booking?.fastTag?.start) - Number(booking?.fastTag?.end || 0)) > 0 ?
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="usedFastTag" className="form-label"> Used FasTag </label>
                                <input name="usedFastTag" readOnly id="usedFastTag" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0))} />
                            </div>
                        </div>
                        :
                        (!isNaN(Number(booking?.fastTag?.end || 0) - Number(booking?.fastTag?.start || 0)) ?
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="usedFastTag" className="form-label"> Refund Fastag </label>
                                    <input name="usedFastTag" readOnly id="usedFastTag" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(Number(booking?.fastTag?.end || 0) - Number(booking?.fastTag?.start || 0))} />
                                </div>
                            </div> : "")
                }

            </div>
            <NextPrev step={1} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Trip;